/* Fresh Reserve — native Shopify Ajax cart drawer + product interactions.
   No dependencies. Uses Shopify Cart AJAX API (/cart/*.js). Money via Shopify. */
(function () {
  var moneyFormat = (window.FR && window.FR.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var noDec = Math.round(cents / 100);
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(noDec))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Cart drawer ---------- */
  var Drawer = {
    open: function () {
      var o = q('#fr-cart-overlay'), d = q('#fr-cart');
      if (o) o.classList.add('is-open');
      if (d) d.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var o = q('#fr-cart-overlay'), d = q('#fr-cart');
      if (o) o.classList.remove('is-open');
      if (d) d.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  function cartItemHTML(item) {
    var opts = (item.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
    return '' +
      '<div class="fr-cart__item" data-key="' + item.key + '">' +
        '<div class="fr-cart__thumb">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>' +
        '<div style="flex:1;min-width:0">' +
          '<div style="display:flex;justify-content:space-between;gap:8px">' +
            '<span style="font-size:14px;font-weight:600;line-height:1.3">' + item.product_title + '</span>' +
            '<span style="font-size:14px;font-weight:700;white-space:nowrap">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          (opts ? '<div style="font-size:12px;color:#8a8a8a;margin:3px 0 10px">' + opts + '</div>' : '<div style="height:6px"></div>') +
          '<div style="display:flex;align-items:center;gap:14px">' +
            '<div class="fr-cart__qty">' +
              '<button type="button" data-fr-qty="-1" data-key="' + item.key + '" aria-label="Decrease">\u2212</button>' +
              '<span style="min-width:24px;text-align:center;font-size:14px;font-weight:600">' + item.quantity + '</span>' +
              '<button type="button" data-fr-qty="1" data-key="' + item.key + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" data-fr-remove="' + item.key + '" style="background:none;border:none;cursor:pointer;color:#999" aria-label="Remove">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0-1 13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1L6 7"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    var itemsEl = q('#fr-cart-items');
    var countEls = qa('[data-fr-cart-count]');
    var totalEl = q('#fr-cart-total');
    var footEl = q('#fr-cart-foot');
    var threshold = (window.FR && window.FR.freeShipThreshold) || 0;

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (itemsEl) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="fr-cart__empty">Your cart is empty.</div>';
        if (footEl) footEl.style.display = 'none';
      } else {
        itemsEl.innerHTML = cart.items.map(cartItemHTML).join('');
        if (footEl) footEl.style.display = '';
      }
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var itemsLabel = q('#fr-cart-itemslabel');
    if (itemsLabel) itemsLabel.textContent = 'Total: ' + cart.item_count + ' Item(s)';

    // free shipping progress
    var fill = q('#fr-cart-shipfill'), shipMsg = q('#fr-cart-shipmsg');
    if (fill && threshold > 0) {
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      fill.style.width = pct + '%';
      if (shipMsg) shipMsg.innerHTML = pct >= 100
        ? "You've Got <b>Free Shipping!</b>"
        : "You're " + formatMoney(threshold - cart.total_price) + " away from <b>Free Shipping</b>";
    }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-fr-add],[data-fr-open-cart],[data-fr-close-cart],[data-fr-qty],[data-fr-remove]') : null;
    if (!t) return;

    if (t.hasAttribute('data-fr-open-cart')) { e.preventDefault(); Drawer.open(); return; }
    if (t.hasAttribute('data-fr-close-cart')) { e.preventDefault(); Drawer.close(); return; }

    if (t.hasAttribute('data-fr-add')) {
      e.preventDefault();
      var form = t.closest('form[data-fr-product-form]');
      var id = form ? form.querySelector('[name="id"]').value : t.getAttribute('data-fr-add');
      var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      t.setAttribute('disabled', 'disabled');
      var label = t.textContent; t.textContent = 'ADDING…';
      addToCart(id, qty).then(function () { return getCart(); }).then(function (cart) {
        render(cart); Drawer.open();
      }).catch(function () {}).then(function () {
        t.removeAttribute('disabled'); t.textContent = label;
      });
      return;
    }

    if (t.hasAttribute('data-fr-qty')) {
      e.preventDefault();
      var key = t.getAttribute('data-key');
      var delta = parseInt(t.getAttribute('data-fr-qty'), 10);
      getCart().then(function (cart) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!item) return;
        return changeCart(key, Math.max(0, item.quantity + delta));
      }).then(function (cart) { if (cart) render(cart); });
      return;
    }

    if (t.hasAttribute('data-fr-remove')) {
      e.preventDefault();
      changeCart(t.getAttribute('data-fr-remove'), 0).then(render);
      return;
    }
  });

  /* ---------- Variant selector + price ---------- */
  function initProductForm(form) {
    var data = form.getAttribute('data-variants');
    if (!data) return;
    var variants = JSON.parse(data);
    var idInput = form.querySelector('[name="id"]');
    var priceNow = q('.fr-price__now', form) || document.getElementById('fr-price-now');
    var priceWas = document.getElementById('fr-price-was');
    var addBtn = form.querySelector('[data-fr-add]');

    function select(variantId) {
      var v = variants.filter(function (x) { return x.id == variantId; })[0];
      if (!v) return;
      idInput.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = formatMoney(v.compare_at_price);
          priceWas.style.display = '';
        } else { priceWas.style.display = 'none'; }
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = 'ADD TO CART'; }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'SOLD OUT'; }
      }
      qa('.fr-variant', form).forEach(function (b) {
        b.setAttribute('aria-current', b.getAttribute('data-variant-id') == v.id ? 'true' : 'false');
      });
    }
    qa('.fr-variant', form).forEach(function (b) {
      b.addEventListener('click', function () { select(b.getAttribute('data-variant-id')); });
    });
    // gallery thumbs
    qa('.fr-thumbs button', document).forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-full');
        var main = document.getElementById('fr-gallery-main');
        if (main && src) main.src = src;
        qa('.fr-thumbs button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Accordions / FAQ ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fr-toggle]') : null;
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('data-fr-toggle'));
    if (!body) return;
    var open = body.hasAttribute('hidden');
    if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
    var sign = btn.querySelector('[data-fr-sign]');
    if (sign) sign.textContent = open ? '\u2013' : '+';
  });

  /* ---------- Sticky bar + count-up ---------- */
  function initScrollFx() {
    var sticky = q('#fr-sticky');
    var savStarted = false;
    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (sticky) sticky.classList.toggle('is-visible', y > 450);
      var sav = q('[data-fr-savings]');
      if (sav && !savStarted) {
        var r = sav.getBoundingClientRect(), vh = window.innerHeight || 800;
        if (r.top < vh * 0.85 && r.bottom > 0) { savStarted = true; animateCounts(); }
      }
    }
    function animateCounts() {
      qa('.fr-count').forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
        var t0 = performance.now(), dur = 1500;
        (function tick(t) {
          var p = Math.min(1, (t - t0) / dur); p = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(target * p).toLocaleString('en-CA') + suf;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setInterval(onScroll, 250);
    onScroll();
  }

  /* ---------- Testimonial carousel (listicle) ---------- */
  function initCarousels() {
    qa('[data-fr-carousel]').forEach(function (root) {
      var slides = qa('.fr-testi', root), dots = qa('.fr-dot', root), i = 0;
      if (!slides.length) return;
      function show(n) {
        i = n;
        slides.forEach(function (s, k) { s.style.display = k === n ? 'block' : 'none'; });
        dots.forEach(function (d, k) { d.style.background = k === n ? '#2f4a37' : '#cfcfcf'; });
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      show(0);
      setInterval(function () { show((i + 1) % slides.length); }, 5000);
    });
  }

  function init() {
    qa('form[data-fr-product-form]').forEach(initProductForm);
    initScrollFx();
    initCarousels();
    getCart().then(render).catch(function () {});
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
